module.exports = "<div ng-if=vm.loading layout=column layout-align=\"center center\" layout-fill class=help-wrapper><gz-spinner if-loading=vm.loading></gz-spinner></div><div ng-if=\"!vm.loading &amp;&amp; vm.errorKey\" class=help-wrapper><gz-error-bar error-key=vm.errorKey></gz-error-bar></div><div ng-if=\"!vm.loading &amp;&amp; !vm.errorKey\" layout=column layout-fill class=help-wrapper><pros-help-viewer page-title=vm.tutorial.title type=vm.tutorial.type url=vm.tutorial.sanitizedUrl show-survey=false></pros-help-viewer></div>";


//////////////////
// WEBPACK FOOTER
// ./components/help/help-wrapper.jade
// module id = 269
// module chunks = 0